import { jsx as _jsx } from "react/jsx-runtime";
import { StatusBubbles } from "../../commoncomponents/StatusBubbles";
import { logWarning } from "../logging/loggingService";
const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;
export const hasValidStageProgression = (item) => {
    var _a, _b, _c, _d;
    return Number.isInteger(item.stageCount) &&
        ((_a = item.stageCount) !== null && _a !== void 0 ? _a : 0) > 0 &&
        Number.isInteger(item.currentStageIndex) &&
        ((_b = item.currentStageIndex) !== null && _b !== void 0 ? _b : -1) >= 0 &&
        ((_c = item.currentStageIndex) !== null && _c !== void 0 ? _c : 0) < ((_d = item.stageCount) !== null && _d !== void 0 ? _d : 0) &&
        isNonEmptyString(item.stageText);
};
const hasAnyStageProgression = (item) => item.stageCount != null ||
    item.currentStageIndex != null ||
    item.stageText != null;
const includesBlocked = (value) => { var _a; return (_a = value === null || value === void 0 ? void 0 : value.toLowerCase().includes("blocked")) !== null && _a !== void 0 ? _a : false; };
const isGetHelpClosedStatus = (status) => status.startsWith("closed") || status.startsWith("resolved");
const isEmTerminalStatus = (status) => status.startsWith("closed") ||
    status.startsWith("resolved") ||
    status.startsWith("complete");
const reportedInvalidProgressionSources = new Set();
const getInvalidProgressionSignature = (item, telemetrySource) => [
    telemetrySource,
    item.stageCount != null,
    item.currentStageIndex != null,
    isNonEmptyString(item.stageText),
].join("|");
export const reportInvalidStageProgression = (item, telemetrySource) => {
    const progressionSignature = getInvalidProgressionSignature(item, telemetrySource);
    if (item.isEscalationManagerCase !== true ||
        hasValidStageProgression(item) ||
        !hasAnyStageProgression(item) ||
        reportedInvalidProgressionSources.has(progressionSignature)) {
        return;
    }
    reportedInvalidProgressionSources.add(progressionSignature);
    logWarning("Invalid EM stage progression; using neutral fallback.", {
        component: "StatusCellRenderer",
        action: "FallbackToUnavailableProgression",
        source: telemetrySource,
        hasStageCount: item.stageCount != null,
        hasCurrentStageIndex: item.currentStageIndex != null,
        hasStageText: isNonEmptyString(item.stageText),
    });
};
export const renderStatusCell = (item, options) => {
    var _a, _b, _c;
    const compact = (_a = options.compact) !== null && _a !== void 0 ? _a : false;
    const normalizedStatus = (_c = (_b = item.status) === null || _b === void 0 ? void 0 : _b.toLowerCase().trim()) !== null && _c !== void 0 ? _c : "";
    if (item.isEscalationManagerCase === true ||
        hasValidStageProgression(item)) {
        if (hasValidStageProgression(item)) {
            return (_jsx(StatusBubbles, { stageCount: item.stageCount, currentStageIndex: item.currentStageIndex, stageText: item.stageText.trim(), isTerminal: isEmTerminalStatus(normalizedStatus), isBlocked: includesBlocked(item.stageText), compact: compact }));
        }
        return (_jsx(StatusBubbles, { stageCount: 2, currentStageIndex: -1, stageText: options.labels.notAvailable, muted: true, compact: compact }));
    }
    if (item.caseCategory === "Consumer") {
        return (_jsx(StatusBubbles, { stageCount: 2, currentStageIndex: -1, stageText: options.labels.notAvailable, muted: true, compact: compact }));
    }
    if (!normalizedStatus) {
        return (_jsx(StatusBubbles, { stageCount: 2, currentStageIndex: -1, stageText: options.labels.notAvailable, muted: true, compact: compact }));
    }
    const isClosed = isGetHelpClosedStatus(normalizedStatus);
    return (_jsx(StatusBubbles, { stageCount: 2, currentStageIndex: isClosed ? 1 : 0, stageText: isClosed ? options.labels.closed : options.labels.open, isTerminal: isClosed, compact: compact }));
};
